import React from 'react';
import { severityBadgeCss } from '../../utils/statusVariant';

interface SeverityBadgeProps {
    severity: string;
}

const SeverityBadge: React.FC<SeverityBadgeProps> = ({ severity }) => (
    <span className={severityBadgeCss(severity)}>
        {severity}
    </span>
);

export default SeverityBadge;
